import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

function useDetailsSelector(property) {
	const detail = useSelector((store) => store.project[property]);
	if (_.isEmpty(detail)) {
		return [];
	}
	return detail;
}

export default useDetailsSelector;
